'use strict'

// App authenticator policy, plus the per-view checkbox used when the policy
// is optional. Off does not ask. Optional keeps the checkbox and still asks
// someone who already enrolled. Required asks every live-app sign-in.
//
// P12 calls ssoSkipsAuthenticator when a session came from SSO and the
// builder chose to skip this factor. Until that choice is saved, pass
// skipAuthenticator false and SSO still asks.

const AUTHENTICATOR_POLICIES = ['off', 'optional', 'required']
const DEFAULT_AUTHENTICATOR_POLICY = 'optional'

function twoFactorSelected (component) {

  if (!component || typeof component !== 'object') return false

  return component.twoFactor === true || component.twoFactor === 'true'
}

function normalizeAuthenticatorPolicy (value) {

  if (value == null || value === '') return DEFAULT_AUTHENTICATOR_POLICY

  if (typeof value !== 'string' || AUTHENTICATOR_POLICIES.indexOf(value) < 0) {

    return { error: 'Authenticator policy must be off, optional, or required' }
  }

  return value
}

function authenticatorPolicyForRead (value) {

  const normalized = normalizeAuthenticatorPolicy(value)

  if (normalized && normalized.error) return DEFAULT_AUTHENTICATOR_POLICY

  return normalized
}

function factorState (record) {

  const enrolled = !!(record && record.secret)

  return {
    enrolled,
    mustEnroll: !!(record && record.pendingEnrollment && !enrolled)
  }
}

function ssoSkipsAuthenticator ({ sessionFromSso, skipAuthenticator } = {}) {

  return sessionFromSso === true && skipAuthenticator === true
}

function loginFactorStep ({ policy, selected, enrolled, mustEnroll, skipForSso } = {}) {

  if (skipForSso) return 'none'

  const mode = authenticatorPolicyForRead(policy)

  if (mode === 'off') return 'none'

  if (enrolled) return 'challenge'

  if (mustEnroll || mode === 'required' || selected) return 'setup'

  return 'none'
}

function registrationNeedsFactor ({ policy, selected, skipForSso } = {}) {

  return loginFactorStep({
    policy,
    selected,
    enrolled: false,
    mustEnroll: false,
    skipForSso
  }) === 'setup'
}

module.exports = {
  AUTHENTICATOR_POLICIES,
  DEFAULT_AUTHENTICATOR_POLICY,
  twoFactorSelected,
  normalizeAuthenticatorPolicy,
  authenticatorPolicyForRead,
  factorState,
  ssoSkipsAuthenticator,
  loginFactorStep,
  registrationNeedsFactor
}
